export const EMPTY = undefined;
export type empty = undefined;
